// @flow

import React from 'react';
import styled from 'styled-components';
import { Page, Title, Text, VSpacer } from '@e4/ui';
import translate from '@e4/intl/translate.macro';

const Content = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const MissingPage = () => {
  return (
    <Page title={translate('app.pageNotFoundTitle')}>
      <Content>
        <VSpacer small={2} medium={4} />
        <Title>{translate('app.pageNotFoundTitle')}</Title>
        <VSpacer small={2} medium={4} />
        <Text>{translate('app.pageNotFoundDescription1')}</Text>
        <Text>{translate('app.pageNotFoundDescription2')}</Text>
        <VSpacer small={2} medium={4} />
      </Content>
    </Page>
  );
};
MissingPage.displayName = 'MissingPage';

export default MissingPage;
